import React from 'react';
import { css } from '@compiled/react';
import { token } from '@atlaskit/tokens';
import { TABLET } from '../../../constants/breakpoints';

const remainderAvatarStyle = css({
  backgroundColor: token('color.background.accent.gray.subtlest'),
  fontFamily: token('font.family.brand.heading'),
  fontWeight: token('font.weight.semibold'),
  lineHeight: '90px',
});

const imageAvatarStyle = css({
  backgroundColor: 'white',
});

const commonStyle = css({
  marginLeft: '-12px',
  width: '90px',
  height: '90px',
  borderRadius: '50%',
  border: `3px solid ${token('color.text.inverse')}`,
  alignItems: 'center',
  justifyContent: 'center',
  display: 'flex',
  fontSize: token('font.size.300'),

  [TABLET.MEDIA_QUERY]: {
    marginLeft: '-14.5px',
  },
  '@media (max-width: 768px)': {
    marginLeft: '-10px',
  },
  '@media (max-width: 420px)': {
    marginLeft: '-23px',
  },
});
interface AvatarProps {
  src?: string;
  name: string;
  isRemainder: boolean;
  displayText?: string;
}

const Avatar: React.FC<AvatarProps> = ({
  src,
  name,
  isRemainder,
  displayText,
}) => {
  const avatarStyle = {
    backgroundImage: `url(${src})`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
  };
  // Different styling for 'remainder avatar' and avatar with no src
  if (isRemainder) {
    return (
      <div
        data-testid={`avatar-${displayText ? 'remainder' : name}`}
        css={[commonStyle, remainderAvatarStyle]}
        style={avatarStyle}
        title={name}
      >
        {displayText}
      </div>
    );
  } else {
    return (
      <div
        data-testid={`avatar-${name}`}
        css={[commonStyle, imageAvatarStyle]}
        style={avatarStyle}
        title={name}
      />
    );
  }
};

export default Avatar;
